/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from '@/axios.js'
import { REPORT_CODES } from '@/constants/reportCodes'

export default {
  fetchStatistics (context, payload) {
    const company   = JSON.parse(localStorage.getItem('activeCompany'))
    return new Promise((resolve, reject) => {
      axios.get(`dashboard/${company.id}/total/${payload.startDate}/${payload.endDate}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchIncomeGraph (context, payload) {
    const company   = JSON.parse(localStorage.getItem('activeCompany'))
    return new Promise((resolve, reject) => {
      axios.get(`report/${company.id}/income-statement/${REPORT_CODES.INCOME_STATEMENT}/${payload.startDate}/${payload.endDate}?showInDashboard=true`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchTopAccount (context, payload) {
    const company   = JSON.parse(localStorage.getItem('activeCompany'))
    return new Promise((resolve, reject) => {
      axios.get(`dashboard/${company.id}/top-account/5/${payload.startDate}/${payload.endDate}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  }
}
